import React, { useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logout } from '../../actions/security';
import {
  localStorageConstants,
  notificationType,
} from '../../constants/globals';
import { createNotification } from '../../utils';
import withTranslations from '../HighOrderComponent';
import authorizationService from './authorizationService';

let startRefreshSignal = true;

const TokenChecker = (props) => {
  const dispatch = useDispatch();
  const { gt, history } = props || {},
    { NotificationMessages } = gt || {};

  const token = localStorage.getItem(localStorageConstants.JWT_TOKEN);
  const refreshToken = localStorage.getItem(
    localStorageConstants.REFRESH_TOKEN
  );
  const TOKEN_EXP_CHECK_INTEVRAL = localStorage.getItem(
    localStorageConstants.TOKEN_EXP_CHECK_INTEVRAL
  );
  const REFRESH_INTERVAL = localStorage.getItem(
    localStorageConstants.REFRESH_INTERVAL
  );

  useEffect(() => {
    let tokenCheckInterval = null;
    let tokenRefreshInterval = false;
    if (token) {
      history.listen(() => {
        const expired = authorizationService.tokenExpirationCheck();
        if (expired) {
          createNotification(
            notificationType.error,
            NotificationMessages?.errorTitle,
            NotificationMessages?.tokenExpired
          );
          dispatch(logout(history));
        }
      });
      if (startRefreshSignal) {
        if (refreshToken) {
          tokenRefreshInterval = setInterval(() => {
            authorizationService.startRefresh(tokenRefreshInterval);
          }, REFRESH_INTERVAL || process.env.REACT_APP_REFRESH_INTERVAL);
        }
        tokenCheckInterval =
          !!NotificationMessages &&
          setInterval(() => {
            const expired = authorizationService.tokenExpirationCheck();
            if (expired) {
              createNotification(
                notificationType.error,
                NotificationMessages?.errorTitle,
                NotificationMessages?.tokenExpired
              );
              dispatch(logout(history));
              clearInterval(tokenCheckInterval);
            }
          }, TOKEN_EXP_CHECK_INTEVRAL || process.env.REACT_APP_TOKEN_EXP_CHECK_INTEVRAL);
      }
      startRefreshSignal = false;
    } else {
      clearInterval(tokenCheckInterval);
      clearInterval(tokenRefreshInterval);
    }
  }, [
    dispatch,
    history,
    token,
    refreshToken,
    TOKEN_EXP_CHECK_INTEVRAL,
    REFRESH_INTERVAL,
    NotificationMessages,
  ]);

  return <Fragment></Fragment>;
};

export default withTranslations(withRouter(TokenChecker));
